<template>
  <div class="container-fluid">
    <ValidationObserver v-slot="{handleSubmit}">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          :name="$t('modal.form.name.label')" 
          rules="required|min:3" 
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.name.label') }}
            <input
              v-model="form.name"
              :placeholder="$t('modal.form.name.placeholder')" 
              type="text"
            >
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.name_ru.label')" 
          rules="required|min:3" 
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.name_ru.label') }}
            <input
              v-model="form.name_ru"
              :placeholder="$t('modal.form.name_ru.placeholder')" 
              type="text"
            >
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.guard_name.label')" 
          rules="required|min:3" 
          v-slot="{ errors }"
        >
          <label>
            {{ $t('modal.form.guard_name.label') }}
            <input
              v-model="form.guard_name"
              :placeholder="$t('modal.form.guard_name.placeholder')" 
              type="text"
            >
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <b-button class="float-end ms-3"
          variant="primary"
                  :disabled="db"
          type="submit"
        >
          {{ $t('modal.button.post') }}
        </b-button>

        <b-button class="float-end"
          variant="warning"
          @click="onClose"
        >
          {{ $t('modal.button.back') }}
        </b-button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  import { postPermissions } from '../../../api/endpoints/permissions'

  export default {
    name: "PermissionsPostModal",
    data() {
      return {
        form: {
          name: "",
          name_ru: "",
          guard_name: ""
        },
        db: false,
      }
    },
    methods:{
      onClose() {
        this.$emit('onClose');
      },
      onSubmit() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        postPermissions(this.form).then( () => {
          this.onClose();
        })
      }
    },
  }
</script>